// src/api/apiClient.ts
import axios from 'axios';
import Cookies from 'js-cookie';

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  //headers: { 'Content-Type': 'application/json' },
 // headers: { 'Content-Type': 'multipart/form-data' },
  headers: {
    'Accept': 'application/json, text/plain, */*', 
  },
});

// Add an interceptor to attach the token from cookies
apiClient.interceptors.request.use((config) => {
  const token = Cookies.get('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Optional: Dispatch a logout action or handle token refresh
    }
    return Promise.reject(error.response?.data || error.message);
  }
);

export default apiClient;
